const getItems = state => state.statistics.items;

const selectors = { getItems };

export default selectors;
